
import React, { Component, useState,useEffect } from 'react';
import axios from 'axios';
import {AppContext} from '../../context/app/appContext';
import {BlogImageUpload} from './iconUpload';
import { Table, Modal, Button, Input } from 'semantic-ui-react'
import { toast } from 'react-toastify';
import { prepareDataForValidation, setNestedObjectValues } from 'formik';

export const Waitlist = (props) => {
    const [waitlist, setWaitlist] = useState([]);
    const [id, setId] = useState(null)
    const [orgName, setOrgName] = useState(null)
    const [showModal, setShowModal] = useState(false)
    var token = localStorage.getItem('accessToken')
    const baseURL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_HOST_URL : 'http://localhost:8080';

    useEffect(()=>{
        // var token = localStorage.getItem('accessToken')
        async function temp(){
            const waitlister = await axios.post(baseURL + '/waitlist/fetch',{
            },{headers : {
                Authorization: "Bearer "+token}
            })
            console.log("fetched waitlist = ",  waitlister.data[0])
            var pending = waitlister.data.filter(item => {return item.approved === false || item.approved === undefined})
            pending = pending.sort(function(a,b) {return new Date(b.createdAt) - new Date(a.createdAt)})
            var approved = waitlister.data.filter(item => {return item.approved === true})
            approved = approved.sort(function(a,b) {return new Date(b.createdAt) - new Date(a.createdAt)})
            // let temp = waitlister.data.filter(item => {return item.approved === false || item.approved === undefined}).sort(function(a,b) {a.createdAt - b.createdAt})
            // temp.push( ...waitlister.data.filter(item => {return item.approved === true}).sort(function(a,b) {a.createdAt - b.createdAt}) )
            // temp.sort(function(a,b) {a.createdAt - b.createdAt})
            setWaitlist([...pending, ...approved])
        }
        temp()
    },[])

    // const table = () => {
    //     const map = []
    //     const waitlisttemp = waitlist
    //     console.log("waitlist temp = ", waitlisttemp[0])
    //     for(let item of waitlisttemp){
    //         map.push(
    //             <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
    //                 <div>{item.companyName}</div>
    //                 <div>{item.firstName}</div>
    //                 <div>{item.lastName}</div>
    //                 <div>{item.email}</div>
    //                 <div>{item.mobile}</div>
    //             </div>
    //         )
    //     }
    //     map.unshift(
    //         <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
    //             <div>Company Name:</div>
    //             <div>First Name:</div>
    //             <div>Last Name:</div>
    //             <div>Email:</div>
    //             <div>Mobile:</div>
    //         </div> 
    //     )
    //     return(map)
    // }

    const setDefaultCards = (id, data) => {
        var temp = waitlist
        temp.filter(item => {return item._id === id})[0].numCards = data.value
        setWaitlist(temp)
        // setWaitlist(prev => {
        //     return prev.map(item => {
        //         if(item._id === id) return { ...item, numCards: val}
        //         else return item
        //     })
        // })
    }

    const approveWaitlist = async () => {
        const current = waitlist.filter(item => {return item._id === id})[0]
        console.log(current.numCards)
        const response = await axios.post(baseURL + "/waitlist/approve", {id, numCards: current.numCards}, {
            headers: {Authorization: "Bearer " + token}
        });
        if(response.status == 200){
            var temp = waitlist
            temp.filter(item => {return (item._id).toString() === id})[0].approved = true
            setWaitlist(temp)
            toast.success("Update successful.", {autoClose: 3000});
        }else{
            setWaitlist(temp)
            toast.error("Unsuccessful.", {autoClose: 3000});
        }
        setShowModal(false)
    }

    const tabletest = () => {
        const map = []
        const waitlisttemp = waitlist
        console.log("waitlist temp = ", waitlisttemp[0])
        for(let item of waitlisttemp){
            const date = new Date(item.createdAt)
            map.push(
                <Table.Row key={(item._id).toString()}>
                    <Table.Cell>{item.companyName}</Table.Cell>
                    <Table.Cell>{item.firstName}</Table.Cell>
                    <Table.Cell>{item.lastName}</Table.Cell>
                    <Table.Cell>{item.email}</Table.Cell>
                    <Table.Cell>{item.mobile}</Table.Cell>
                    <Table.Cell>{item.jobRole === undefined ? 'Rep' : item.jobRole}</Table.Cell>
                    <Table.Cell>{`${date.getMonth()+1}-${date.getDate()}-${date.getFullYear()}`}</Table.Cell>
                    <Table.Cell>
                        <Input type="number" defaultValue={item.numCards} onChange={(e, data) => {setDefaultCards(item._id, data)}}/>
                    </Table.Cell>
                    <Table.Cell>{item.approved === false || item.approved === undefined ? (<button className="ui button" onClick={e => {setId(String(item._id)); setShowModal(true); setOrgName(item.companyName)}}>{'Approve'}</button>) : 'Approved'}</Table.Cell>
                </Table.Row>
            )
        }
        return(
            map
        )

    }
    return(
        <React.Fragment>
            <div >NOTE: PLEASE FOLLOW A TOP DOWN APPROACH.</div>
            <Table celled>
                <Table.Header>
                <Table.Row>
                    <Table.HeaderCell>Company Name</Table.HeaderCell>
                    <Table.HeaderCell>First Name</Table.HeaderCell>
                    <Table.HeaderCell>Last Name</Table.HeaderCell>
                    <Table.HeaderCell>Email</Table.HeaderCell>
                    <Table.HeaderCell>Mobile</Table.HeaderCell>
                    <Table.HeaderCell>Title</Table.HeaderCell>
                    <Table.HeaderCell>Date</Table.HeaderCell>
                    <Table.HeaderCell>Cards</Table.HeaderCell>
                    <Table.HeaderCell></Table.HeaderCell>
                </Table.Row>
                </Table.Header>

                <Table.Body>
                    {tabletest()}
                </Table.Body>

            </Table>
            {/* {waitlist ? table() : <div>Loading</div>} */}
            <Modal dimmer={'blurring'} open={showModal}
                        size="small" onClose={() => setShowModal(false)}>
                        <Modal.Content style={{  }}>
                            <p>Are you sure you want to approve {orgName}?</p>
                        </Modal.Content>
                        <Modal.Actions className="center aligned">
                            <Button onClick={() => setShowModal(false)}>Cancel</Button>
                            <Button className="primary" content="Save"
                                onClick={() => approveWaitlist()} />
                        </Modal.Actions>
                    </Modal>
        </React.Fragment>
    )
}